// extracted by mini-css-extract-plugin
export default {"root":"FeedbackModal_root__AOkx7","controls":"FeedbackModal_controls__iDAbk"};